import i18n from 'i18next'

export const formFieldRules = {
	text: [{ required: true, message: i18n.t('Text is required') }],
}
